import { computed, makeObservable, observable } from 'mobx'

import { EMPTY_NUMBER_ID } from '@/constant/common'
import commonRepo from '@/repository/common.repo'
import { curriculumCoreService } from '@/service/curriculumCore.service'
import dateUtils from '@/utils/DateUtils'

import { DTO } from '../DTO'
import { SchoolGrade } from '../Student'

export class Paper extends DTO {
  id: res.Paper['id'] = EMPTY_NUMBER_ID
  type: res.Paper['type'] = 'SCHOOL_TEST_PAPER'
  title: res.Paper['title'] = ''
  schoolName: res.Paper['schoolName'] = null
  schoolCode: res.Paper['schoolCode'] = null
  schoolTestYear: res.Paper['schoolTestYear'] = null
  schoolTestType: res.Paper['schoolTestType'] = null
  gradeSemester: res.Paper['gradeSemester'] = ''
  trieKey: res.Paper['trieKey'] = ''
  pdfUrl: res.Paper['pdfUrl'] = ''
  pages: res.Paper['pages'] = []
  boxes: res.Paper['boxes'] = []
  createDatetime: Date = new Date()

  constructor(data: res.Paper) {
    super()

    if (data) {
      Object.assign(this, data)
    }

    this.createDatetime = new Date(data.createDatetime)

    makeObservable(this, {
      id: observable,
      type: observable,
      title: observable,
      schoolName: observable,
      schoolCode: observable,
      schoolTestYear: observable,
      schoolTestType: observable,
      gradeSemester: observable,
      trieKey: observable,
      pdfUrl: observable,
      pages: observable,
      boxes: observable,
      createDatetime: observable,
      korGradeSemester: computed,
      isNew: computed,
      isUsable: computed,
    })
  }
  get korGradeSemester() {
    const info = curriculumCoreService.getItemByTrieKey(this.trieKey)
    if (!info) return '중 1-1'
    return SchoolGrade.getKoreanWorkbookGradeSemesterRevision({
      type: 'ALL',
      schoolType: info.schoolType as common.SchoolType,
      grade: info.gradeSubject,
      semester: info.semester,
      revision: info.revision,
    })
  }
  get isNew() {
    return dateUtils.isIn24Hours(this.createDatetime)
  }
  get isUsable() {
    if (commonRepo.isSolo) {
      return commonRepo.permission.bySubscription.validateSubscription({
        trieKey: this.trieKey,
      })
    }
    return true
  }

  setPages(pages: res.Paper['pages']) {
    this.pages = pages
  }
}
